export default {
	title: '设备管理',
	actions: {
		add: '新增',
		edit: '修改',
		delete: '删除',
		batchDelete: '批量删除',
		save: '保存',
		cancel: '取消',
		confirm: '确定'
	},
	messages: {
		deleteSuccess: '删除成功',
		actionSuccess: '操作成功',
		noValidSensor: '请至少填写一个完整的测点信息'
	},
	labels: {
		deviceList: '设备列表',
		startStopRecord: '启停记录',
		diagnose: '诊断',
		node: '节点',
		device: '设备',
		sensor: '传感器',
		org: '机构',
		addNode: '添加{type}',
		editNode: '修改{type}'
	},
	table: {
		name: '名称',
		deviceTypeId: '设备类型',
		status: '状态',
		action: '操作'
	},
	form: {
		placeholder: {
			name: '请输入名称',
			deviceTypeId: '请选择设备类型'
		}
	},
	dialog: {
		add: '新增',
		edit: '修改',
		addDevice: '新增设备',
		addSensor: '新增传感器',
		addOrg: '新增机构',
		editDevice: '修改设备',
		editSensor: '修改传感器',
		editOrg: '修改机构'
	},
	buttons: {
		add: '添加',
		edit: '修改',
		delete: '删除',
		save: '保存',
		cancel: '取消',
		confirm: '确定',
		diagnose: '诊断',
		startStopRecord: '启停记录'
	},
	deviceCom: {
		add: '添加',
		save: '保存',
		addDevice: '新增',
		deviceModelImage: '设备模型图'
	},
	sensorCom: {
		add: '添加',
		save: '保存',
		addSensor: '新增'
	},
	orgCom: {
		save: '保存',
		addOrg: '新增'
	},
	config: {
		gridLayout: '格栅布局',
		superiorDepartment: '上级部门',
		orgPlaceholder: '机构 (诊断)',
		name: '名称',
		nameRequired: '必填项不能为空',
		icon: '图标',
		location: '具体位置',
		type: '类型',
		label1: '标签 1'
	},
	orgTree: {
		expandAll: '展开全部',
		collapseAll: '收起全部',
		filterPlaceholder: '请输入关键字过滤',
		deleteConfirm: '确定要删除该节点吗？',
		deleteTitle: '提示'
	},
	index: {
		deviceList: '设备列表',
		startStopRecord: '启停记录',
		nodeTitle: {
			device: '设备',
			sensor: '传感器',
			org: '机构',
			node: '节点'
		},
		addNodeTitle: '添加{type}',
		editNodeTitle: '修改{type}'
	}
}
